module.exports = __webpack_public_path__ + "static/media/5-th.75fd8ba.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/5-th.wav
// module id = mhHY
// module chunks = 1